module.exports = __webpack_public_path__ + "img/thomas-aeschleman-BG8te7fVCqU-unsplash.397dd0cb.jpg";